import firebase from 'firebase/compat/app';
import firestore from 'firebase/compat/firestore';
import auth from 'firebase/compat/auth';
import functions from 'firebase/compat/functions'

const firebaseConfig = {
    apiKey: "AIzaSyDFoGSfSftZsTCF6mM8i57qiW95xjjxZ-Y",
    authDomain: "sweethe-commande.firebaseapp.com",
    projectId: "sweethe-commande",
    storageBucket: "sweethe-commande.appspot.com",
    messagingSenderId: "263955089888",
    appId: "1:263955089888:web:8b89779ec84241a5b68385",
    measurementId: "G-2LBGBX9R9F"
};




// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const fireauth = firebase.auth();
const firefunctions = firebase.functions()
/*
if(process.env.NODE_ENV ==="development") {
    console.log("fireme fire you to Dev")
    firefunctions.useEmulator("localhost",5000)
    
}
*/
const Timestamp= firebase.firestore.Timestamp
export {Timestamp, db, fireauth,firefunctions };
